<template>
  <div class="panel" >
    <div class="panel-heading">
      <div class="panel-title">
        <h4>Ajouter un encaissement</h4>
      </div>
    </div>
    <div class="panel-body">
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Choix du client</label>
          <search-and-select :initial-value="selectedCustomer"
            :search-config="cashingsCustomerSearchConfig"
            :get-option-label="getCustomerNameWithRepresentativeAndErpId"
            @field-updated="updateCustomer">
          </search-and-select>
        </div>
        <div class="balance-container form-group col-sm-6">
          <label>Balance client</label>
          <div class="balance-container-inner">
            <ul v-if="selectedCustomer && balance">
              <li>Solde Sofradom : <span>{{(balance.sofradom / 100 ).toFixed(2)}}€ </span></li>
              <li>Solde ABC + : <span>{{(balance.abc_plus / 100 ).toFixed(2)}}€ </span></li>
              <li>Solde SDM : <span>{{(balance.sdm / 100 ).toFixed(2)}}€ </span></li>
              <li><strong>Solde Total : <span>{{(balance.total / 100 ).toFixed(2)}}€</span> </strong></li>
            </ul>
            <p v-else>N/A</p>
          </div>
        </div>
      </div>
      <div class="customer-step">
      </div>
      <div v-if="selectedCustomer">
        <div class="form-group">
          <label>Email à utiliser pour les notifications de paiement</label>
          <custom-email :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="email_for_payment_notifications = $event.new_value">
          </custom-email>
        </div>

        <div class="form-group">
          <label>Type d'encaissement</label>
          <custom-select :field="fields[1]" :value="fields[1]" :field_idx="1" @field-updated="selected_cashing_type = $event.new_value">
          </custom-select>
        </div>

        <div v-if="selected_cashing_type && selected_cashing_type.value">
          <div v-if="selected_cashing_type.value === 'free'">
            <div class="form-group">
              <label>Organisation</label>
              <custom-select v-if="filteredOrganizations.length > 1" :field="fields[2]" :value="fields[2]" :field_idx="2" @field-updated="selected_organization = $event.new_value">
              </custom-select>
              <p v-else-if="filteredOrganizations.length == 1">{{filteredOrganizations[0].display_name}} (sélectionnée par défaut)</p>
              <p v-else>Ce client ne fait partie d'aucune organisation.</p>
            </div>
            <div class="form-group">
              <label>Montant</label>
              <custom-text :field="fields[3]" :value="fields[3].value" :field_idx="3" @field-updated="selected_amount = $event.new_value">
              </custom-text>
            </div>
          </div>

          <div v-else-if="selected_cashing_type.value === 'invoices'">
            <div class="form-group">
              <label>Factures</label>
              <ul v-if="filteredInvoices.length">
                <li v-for="invoice in invoicesForSelect(filteredInvoices)"  class="full-width">
                  <input type="checkbox" v-model="selected_invoices" :value="invoice.id"></input>
                  <label>{{invoice.name}}</label>
                </li>
              </ul>
              <p v-else> Aucune factures en attente de paiement pour ce client.</p>
              <div v-if="selected_invoices">
                Montant total des factures sélectionnées :
                <input :disabled="this.conditionsForDisabling"
                      type="number" :min="fullAmount"
                      v-model="selected_amount">€
                      <!-- v-model="selected_amount" @change="checkValidAmount">€ -->
              </div>
            </div>
          </div>
        </div>

        <div v-if="missingDatas.length > 0">
          <ul>
            <li v-for="md in missingDatas"><strong style="color:red;">{{md.message}}</strong></li>
          </ul>
        </div>

        <div style="padding:10px 0;">
          <button class="btn" style="float:left;" @click="resetFields">
            <i class="fa fa-refresh"></i>
            <span>Annuler</span>
          </button>
          <button class="btn btn-complete" style="float:right;" @click="addCash()" v-if="!checkIfReadyTosend">Effectuer l'encaissement</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .balance-container-inner { border-radius: 5px; background-color: #eaeaea; padding: 8px 10px; }
  .balance-container-inner > * { margin: 0; }
</style>

<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import vSelect from 'vue-select'
  import SearchAndSelect from "components/Forms/Elements/SearchAndSelect"
  import CustomSelect from "components/Forms/Elements/Select"
  import CustomText from "components/Forms/Elements/Text"
  import CustomCheckbox from "components/Forms/Elements/Checkbox"
  import CustomEmail from "components/Forms/Elements/Email"

  import customerMixin from 'mixins/customer'
  import searchMixin from 'mixins/search'

  export default {
      name:"AddCashForm",

      components: {
          SearchAndSelect,
          vSelect,
          CustomText,
          CustomCheckbox,
          CustomSelect,
          CustomEmail
      },

      mixins: [customerMixin, searchMixin],

      data () {
          return {
            customerOptions: [],
            selectedCustomer: null,
            email_for_payment_notifications: null,
            cashing_types: [
              {name: "Encaissement libre", id: "free"},
              {name: "Factures", id: "invoices"},
            ],
            selected_cashing_type: null,
            selected_organization: null,
            selected_amount: 0,
            selected_invoices: [],
            debouncedCustomerResearch: null,
            missing_datas: [
              {customer: "Client manquant."},
              {email: "Email manquant."},
              {organization: "Organisation manquante."},
              {invoices: "Facture(s) manquantes."},
              {amout: "Montant manquant."},
              {type: "Type de paiement manquant."}
            ],
            email_regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
          }
      },

      methods: {
        ...mapActions('cash', ['customersOfAgencyForAdd',
                              'storeCustomerCashing',
                              'customerCashings',
                              'invoicesOf',
                              'agenciesWithOrganization',
                              'searchCustomerForAddCash',
                              'resetCustomerForAddCash',
                              'organizationsOfCustomer',
                              'fetchCustomerBalance',
                            ]),

        resetFields() {
          this.selectedCustomer = null,
          this.selected_organization = null,
          this.selected_cashing_type = null,
          this.selected_amount = 0,
          this.email_for_payment_notifications = null,
          this.selected_invoices = [],
          this.resetCustomerForAddCash()
        },

        addCash() {
          this.storeCustomerCashing({
            customer_id: this.selectedCustomer.id,
            organization_id: 'invoices' != this.selected_cashing_type.value ? this.selected_organization.value : null,
            type: this.selected_cashing_type.value,
            ttc_amount: Math.round((this.selected_amount * 100) * 100) / 100,
            email: this.email_for_payment_notifications,
            invoices: this.selected_invoices
          })
          .then(() => this.resetFields())
        },

        invoicesForSelect(new_invoices) {
          return _.map(new_invoices, (invoice) => {
            if (invoice != null)
              return {id:invoice.id, name:(invoice.erp_id + ' - ' + moment(invoice.created_at).format('DD/MM/YYYY') + ' - ' + (invoice.ttc_amount / 100).toFixed(2) + '€' + ' - ' + this.get_orga_name(invoice.organization_id))}
          })
        },

        fieldIsMissing(field_name) {
          return _.find(this.missingDatas, mdata => mdata.field_name == field_name) == undefined
        },

        getMissingMessage(field_name) {
          return _.find(this.missingDatas, mdata => mdata.field_name == field_name).message
        },

        get_orga_name(org_id)
        {
          var found = _.find(this.organizations, org => org.id == org_id)
          if (found)
            return found.display_name
        },

        checkValidAmount(event){
          if (Number(this.selected_amount) < Number(this.fullAmount))
            this.selected_amount = this.fullAmount
        },

        updateCustomer(event)
        {
          this.selectedCustomer = event
        }
      },

      watch: {

        selectedCustomer: function (newv, oldv) {
          let customer = newv

          if (customer)
          {
            // Partial reset
            this.selected_invoices = []
            this.selected_organization = null
            this.selected_cashing_type = null
            this.selected_amount = 0

            // Customer related
            if ( customer.main_representative && customer.main_representative.email && customer.main_representative.email.length > 0 )
              this.email_for_payment_notifications = customer.main_representative.email
            else
              this.email_for_payment_notifications = null

            // Balance
            this.organizationsOfCustomer(customer.id)
                .then(() => this.fetchCustomerBalance({"customerId": customer.id, "refresh": 1}))

            // Invoices
            this.invoicesOf({customer_id: customer.id, params:{customer_id: customer.id, paid: 0}})
          }
        },

        selected_cashing_type : function(newv, oldv) {
          let cashing_type = newv

          if (cashing_type && cashing_type.value && cashing_type.value === "invoices")
            this.invoicesOf({customer_id: this.selectedCustomer.id, params:{customer_id: this.selectedCustomer.id, paid:0}})
          else
            this.selected_invoices = []
        },

        selected_amount(newv, oldv) {
          if (newv != null && typeof(newv) == "string")
            this.selected_amount = newv.replace(',', '.')
        },

        filteredOrganizations(newv, oldv) {
          let organizations = newv

          if (organizations.length == 1) {
            let defaultOrganization = organizations[0]

            this.selected_organization = {
              label: defaultOrganization.name,
              value: defaultOrganization.id
            }
          }
        },

        selected_invoices () {
          this.selected_amount = this.fullAmount
        },

     },

      computed: {
        ...mapState(['user', 'agencies']),
        ...mapState('cash', ['invoices','organizations','balance']),

        checkIfReadyTosend() {
          return this.missingDatas.length > 0 ? true : false
        },

        fullAmount() {
          var total = 0
          _.each(this.selected_invoices, invoice_id => {
            var found = _.find(this.invoices, invoice => invoice.id == invoice_id)
            if (found != undefined)
              total += found.ttc_amount
          })
          return (total / 100).toFixed(2)
        },

        missingDatas() {
          var missings = []

          if (!this.email_for_payment_notifications)
            missings.push({field_name:"email_for_payment_notifications", message:"Email pour les notifications de paiement manquant."})
          else if (this.email_regexp.test(this.email_for_payment_notifications) == false)
            missings.push({field_name:"email_for_payment_notifications", message:"Format de l'email invalide."})
          if (!this.selected_cashing_type)
            missings.push({field_name:"selected_cashing_type", message:"Type d'encaissement manquant."})
          else if (this.selected_cashing_type.value)
          {
            if (this.selected_cashing_type.value === "free")
            {
              if (!this.selected_organization)
                missings.push({field_name:"selected_organization", message:"Organisation manquante."})
              if (this.selected_amount <= 0)
                missings.push({field_name:"selected_amount", message:"Montant invalide (<= 0€)."})
            }
            else if (this.selected_cashing_type.value === "invoices")
            {
              if (this.selected_invoices == null )
                missings.push({field_name:"selected_invoices", message:"Factures manquantes."})
              else if (this.selected_invoices.length == 0)
                missings.push({field_name:"selected_invoices", message:"Aucune facture sélectionnée pour ce client."})
              if (_.uniqBy(this.selected_invoices, id => {
                var found = _.find(this.invoices, invoice => invoice.id == id)
                if (found)
                  return found.organization_id
              }).length > 1)
                  missings.push({field_name:"selected_invoices", message:"Les factures sélectionnées concernent plusieurs agences différentes."})
            }
          }
          return missings
        },

        conditionsForDisabling() {
          if (_.uniqBy(this.selected_invoices, id => {
            var found = _.find(this.invoices, invoice => invoice.id == id)
            if (found)
              return found.organization_id
          }).length == 1)
            return false
          return true
        },

        filteredOrganizations() {
          return _.chain(this.organizations).filter(function(o) { return o.disabled_for_tup === false; }).value()
        },

        filteredInvoices() {
          return _.chain(this.invoices).filter(function(i) { return 1 === i.organization_id; }).value()
        },

        fields() {
          let v = [
            {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:0, required:true, value:this.selectedCustomer.main_representative.email , label:"",type:"text"},
            {values:this.cashing_types, multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:true, value:this.selected_cashing_type , label:"",type:"select"},
            {values:this.filteredOrganizations, multiple:false, placeholder:"", disabled:this.is_fetching, idx:2, required:true, value:this.selected_organization , label:"",type:"select"},
            {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:3, required:true, value:this.selected_amount, label:"",type:"text"},
            {values:this.filteredInvoices, multiple:false, placeholder:"", disabled:this.is_fetching, idx:3, required:true, value:this.selected_amount, label:"",type:"checkbox"},
          ]
          return v
        }

      },

      created() {
        this.debouncedCustomerResearch = _.debounce(this.searchCustomerForAddCash, 300)
      },
  }
</script>



// WEBPACK FOOTER //
// client/components/Cash/AddCashForm.vue